export default "__VITE_ASSET__mk7SL8Gu__"